import React from 'react';
import StudyCard from '../studiesPage/studyPage';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { styled } from '@mui/system';
import StudyFormForUser from '../studyFormForUser/studyFormUser'
import ActivityPageForUser from '../activityPageForUser/activityPageForUser'
import EmailForm from '../emailPage/emailPage';
import FileUploadComponent from '../studyDocuments/studyDocument';
import ActiveStudyFormUser from '../activeStudyFormUser/activeStudyFormUser';
import ActiveStudyDocumentForUser from '../activeStudyDocumentForUser/activeStudyDocumentForUser';
const StyledTab = styled(Tab)({
    fontSize: '1.1rem',
    fontWeight: '600', // Increased label size
    color: '#008B8B', // Default color
    '&:hover': {
        color: '#169a8f', // Change color to yellow on hover
    },
    '&.Mui-selected': {
        color: '#169a8f', // Change color to blue for the active tab
    },
    paddingLeft: '10px',
    marginRight: '50px', // Add spacing between tabs
    fontFamily:'nunito'

});


const StyledTabList = styled(TabList)({
    background: '#E0F2F1', /* Fallback for old browsers */
    background: '-webkit-linear-gradient(to left, #B2DFDB, #E0F2F1)', /* Chrome 10-25, Safari 5.1-6 */
    background: 'linear-gradient(to left, #B2DFDB, #E0F2F1)', /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    backgroundColor: '#ffffff', // Background color
    color: '#169a8f',
    display: 'flex', // Flexbox display
    justifyContent: 'around', // Centering tabs
    alignItems: 'center' // Aligning items vertically
});


function ActiveStudyFormForUser({ setShowSpinner, data }) {
    const [value, setValue] = React.useState('1');

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };


    return (

        <div className='mt-3'>
            <Box sx={{ width: '100%', typography: 'body1' }}>
                <TabContext value={value}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <StyledTabList onChange={handleChange} aria-label="lab API tabs example">
                            <StyledTab label="Study" value="1" />
                        </StyledTabList>
                    </Box>
                    <TabPanel value="1">
                        <StudyFormForUser setShowSpinner={setShowSpinner} data={data} />
                    </TabPanel>
                </TabContext>
            </Box>
        </div>

    );
}

export default ActiveStudyFormForUser;
